import { combineTokens } from '@utils/css';

combineTokens("--all-link", {
  extraTransform: ""
});
const linkCls = "_j0jl1gno8rn";
const chevronWrapperCls = "_j0jc1kigg2n";
const chevronCls = "_j0jc1dpnm8p";

export { chevronCls, chevronWrapperCls, linkCls };
import "./all-link.style.linaria.module.css";
//# sourceMappingURL=all-link.style.js.map
